import { useMutation } from '@tanstack/react-query';

import { useAuth0 } from '@auth0/auth0-react';
import type { useCart } from 'src/api/queries';
import { StripeIntentType, useStripe } from 'src/utils/stripe';

import { useCheckoutType } from '../useCheckoutType';
import type { CheckoutFormState } from './Checkout.types';

export const useCheckout = (cart: ReturnType<typeof useCart>) => {
  const checkoutType = useCheckoutType();
  const stripeIntentType: StripeIntentType =
    checkoutType === 'store'
      ? StripeIntentType.Payment
      : StripeIntentType.Setup;
  const stripeCheckout = useStripe(stripeIntentType);
  const auth = useAuth0();

  return useMutation({
    mutationFn: async (formState: CheckoutFormState) => {
      const county = formState.state || formState.province || '';
      const confirmationPagePath = window.location.pathname.replace(
        '/checkout',
        '/confirmation'
      );

      await stripeCheckout.checkout.mutateAsync({
        mandate_data: JSON.parse(
          atob(cart.setup.data?.encodedMandateData ?? '') || '{}'
        ) as Record<string, unknown>,
        return_url: `${window.location.origin}${confirmationPagePath}`,
        payment_method_data: {
          billing_details: {
            name: [formState.firstName, formState.lastName]
              .filter(Boolean) // remove nullish values
              .join(' '),
            email: auth.user?.email,
            address: {
              line1: formState.billingAddress1 ?? '',
              line2: formState.billingAddress2 ?? '',
              city: formState.city ?? '',
              state: county,
              country: formState.country ?? '',
              postal_code: formState.postalCode ?? '',
            },
            phone: '',
          },
        },
      });
    },
  });
};
